import React from "react";
import Icon from "./Icon";
export default function Check(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5.5L8.24996 15.5833L3.66663 11"
  }));
}
Check.displayname = "Check";
//# sourceMappingURL=Check.js.map